<template>
  <div class="home">
    <NavbarMain />
    <div class="container py-5">
      <div v-html="html"></div>
    </div>
  </div>
</template>

<script>
import Api from "../tools/Api2";
import { mapState, mapMutations } from "vuex";
import NavbarMain from "@/components/NavbarMain.vue";

export default {
  name: "Tyc",
  data() {
    return {
      html: "",
    };
  },
  components: {
    NavbarMain,
  },
  mounted: function() {
    Api("tyc")
      .get()
      .then((res) => {
        if (!res.error) this.html = res.text;
      });
  },
  computed: {
    ...mapState(["counters", "flag"]),
  },
  methods: {
    ...mapMutations(["setCounters"]),
  },
};
</script>

<style lang="css" scoped>
.home {
  height: 100%;
}
</style>
